import { Box, Group, Skeleton, Stack } from '@mantine/core';

type FilesTableSkeletonProps = {
  columnCount: number;
  rows?: number;
  compact?: boolean;
};

export default function FilesTableSkeleton({
  columnCount,
  rows = 6,
  compact = false,
}: FilesTableSkeletonProps) {
  const rowHeight = compact ? 20 : 28;
  const trailingColumns = Math.max(columnCount - 1, 0);

  return (
    <Box p="xs" data-testid="files-table-skeleton">
      <Stack gap={compact ? 'sm' : 'md'}>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <Group key={rowIndex} justify="space-between" wrap="nowrap" gap="md">
            <Group gap="sm" wrap="nowrap" style={{ flex: 1 }}>
              <Skeleton height={rowHeight} circle width={rowHeight} />
              <Skeleton height={rowHeight} width="40%" radius="sm" />
            </Group>
            {Array.from({ length: trailingColumns }).map((__, colIndex) => (
              <Skeleton key={colIndex} height={rowHeight} width={80} radius="sm" />
            ))}
          </Group>
        ))}
      </Stack>
    </Box>
  );
}
